module.exports = __webpack_public_path__ + "static/r3-05baebce336d42eee02940ce1c0aae6d.svg";